import React from 'react'

export const RbkIcon = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="49.5"
        height="49.5"
        rx="24.75"
        fill="#F3F3F3"
        stroke="#F3F3F3"
        stroke-width="1.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.5 25.5C49.5 38.7548 38.7548 49.5 25.5 49.5C12.2452 49.5 1.5 38.7548 1.5 25.5C1.5 12.2452 12.2452 1.5 25.5 1.5C38.7548 1.5 49.5 12.2452 49.5 25.5ZM35.5229 13.5H13.5V35.4562L35.5229 13.5ZM37.5004 37.4999H15.4775L37.5004 15.5215V37.4999Z"
        fill="#0AB77B"
      />
    </svg>
  )
}
